import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchTrainersState } from "../../../interfaces/store/trainers-interfaces";
import { CARDS_PAGE_SIZE } from "../../../common/config";

const initialState: IFetchTrainersState = {
  trainers: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: CARDS_PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchTrainersStart = (
  state: IFetchTrainersState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchTrainersSuccess = (
  state: IFetchTrainersState,
  { payload }: PayloadAction<any>
) => {
  state.trainers = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchTrainersFailed = (
  state: IFetchTrainersState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetTrainers = (state: IFetchTrainersState) => {
  return { ...initialState };
};

const TrainersSlice = createSlice({
  name: "trainers",
  initialState,
  reducers: {
    fetchTrainersStart: _fetchTrainersStart,
    fetchTrainersSuccess: _fetchTrainersSuccess,
    fetchTrainersFailed: _fetchTrainersFailed,
    resetTrainers: _resetTrainers,
  },
});

export const {
  fetchTrainersStart,
  fetchTrainersSuccess,
  fetchTrainersFailed,
  resetTrainers,
} = TrainersSlice.actions;
export default TrainersSlice.reducer;
